module.exports = __webpack_public_path__ + "img/navbar_hoverMenu_3_2.63b4a460.png";